import { render, staticRenderFns } from "./passwordUpdate.vue?vue&type=template&id=67efb007&"
import script from "./passwordUpdate.vue?vue&type=script&lang=js&"
export * from "./passwordUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports